var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPharmacology(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5BA5ED",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M22.065,23.454l-3.487-5.989 c-0.261-0.389-0.496-0.763-0.708-1.121c0,0-0.162-0.329-0.261-0.45c-1.067-1.898-1.458-3.278-1.601-4.02 c-0.112-0.917-0.058-1.553-0.058-1.553v-5.23c1.592-1.421-0.341-2.046-0.341-2.046h-4.775c0,0-1.896,0.702-0.114,2.218v5.988 c0,0-0.038,2.312-2.653,6.215l-3.486,5.989c0,0-1.365,2.35,1.213,3.031h4.853h1.438h8.768 C23.431,25.804,22.065,23.454,22.065,23.454z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M14.186,25.463H6.249 c0,0-1.743-0.037-0.796-1.44l4.51-7.845h6.708l1.608,2.562"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFB3BC",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    cx: 9.441,
    cy: 22.971,
    r: 1.194
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFB3BC",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    cx: 14.475,
    cy: 20.22,
    r: 1.194
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFB3BC",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    cx: 12.653,
    cy: 13.932,
    r: 1.222
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M22.583,22.128l3.336-3.411 c1.023-2.274-0.379-3.639-0.379-3.639c-1.857-2.046-4.131-0.985-4.131-0.985l-8.528,8.301c0,0-1.554,1.97,0.303,4.131 c0,0,1.023,1.288,3.221,1.023"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "#FFB3BC",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    x1: 16.975,
    y1: 18.375,
    x2: 20.916,
    y2: 22.317
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB3BC",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M16.292,24.819v2.86 c0,1.351,2.724,2.445,6.082,2.445c3.361,0,6.084-1.095,6.084-2.445v-3.032"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M14.217,22.432c0,0-1.961,1.904,0.114,3.58"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#FFB3BC",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    cx: 22.375,
    cy: 24.647,
    rx: 6.083,
    ry: 2.445
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "#FFB3BC",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    x1: 19.96,
    y1: 26.865,
    x2: 24.962,
    y2: 22.459
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPharmacology);
export default __webpack_public_path__ + "static/media/pharmacology.6906300303f2fe32fe29050f0f86208a.svg";
export { ForwardRef as ReactComponent };